<template>
  <div>
    <v-layout row wrap align-center justify-center class="mt-5">
      <v-flex xs12 sm6 md5 lg5>
        <v-hover>
          <v-card
            class="text-xs-center ma-3"
            slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
          >
            <v-card-title>
            <v-layout row wrap align-center justify-center class="mt-2">
              
            <span class="headline font-weight-bold">Additional details of Business Growth</span> 
              <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify mt-3"
                outline>
                <span>Tip: If the product sells well, How would you handle scale? <br/>A few typical responses include:
                    <ul>
                        <li>
                            "I intend to use a cloud service provider such as AWS, Firebase or Azure."
                        </li>
                        <li>
                            "I intend to hire a team dedicated to handle server infrastructure."
                        </li>
                        <li>
                            "I intend to outsource all tasks concerning this matter."
                        </li>
                    </ul> </span> 
                
              </v-alert>
              <!-- <v-btn flat small :href="linktolfwireframe" target="_blank" class="mx-2 font-weight-light" align-center justify-center>Learn more about Wireframes</v-btn>  -->
              </v-layout>
            </v-card-title>
            <v-card-text>
              <v-form class="px-3" ref="form">
                <!-- <span v-for="(customerproblemdetail, index) in customerproblemdetails" :key="index"> -->
                  <!-- <v-layout row wrap>  -->

                 <v-textarea
                  outline   
                  :rules="textInputRules"
                  :label="handlingscaleLabel"
                  v-model="handlingscaledetails"
                  :hint="handlingscaleHintText"
                >
                 </v-textarea> 


                <v-select
                        v-model="isthegrowthsustainable"
                        :items="growthsustainableoptions"
                        :label="isthegrowthsustainablegrowthLabel"
                        :rules="selectInputRules" 
                        outline
                        ></v-select>

 

                
<!--                 
                <v-textarea outline class="mt-3"
                :label="metricevolutionLabelText" 
                v-model="metrictitle" :hint="metricevolutionHintText" 
                :rules="textInputRules"></v-textarea>

                <v-textarea outline
                :label="metricecosystemLabelText" 
                v-model="metrictitle2" :hint="metricecosystemHintText" 
                ></v-textarea> -->

                

                <v-spacer></v-spacer>
                <v-btn flat @click="$router.go(-1)" class="mx-4 mt-3">Head back</v-btn>
                <!-- <v-btn flat @click="submit" color="primary" class="mx-2 mt-3" :loading="loading">Add details</v-btn> -->
                <v-btn to="/dumaddparallelinnovations" flat color="primary" class="mx-2 mt-3" :loading="loading"><!--Add details--> Go Next</v-btn>  
                
              </v-form>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
  name: "problemstudy",
  components: {},
  data() {
    return {
      doWe: false, 
      handlingscaledetails: 'I intend to use a cloud service provider such as AWS, Firebase or Azure.',
      handlingscaleLabel:'How would you handle scale?',
      handlingscaleHintText: 'Please provide details on how the scaling aspect of the solution would be handled. Determing this would help the business handle issues associated with a sudden increase or decrease in the usage of the product such as datacenter costs or infrastructure availability. ',
      
      isthegrowthsustainable: 'No',
            growthsustainableoptions: ['Yes', 'No'],
            isthegrowthsustainablegrowthLabel: 'Is the currently chosen growth strategy sustainable?',
      
      metrictitle: 'Ratio of relevance of disruptive competing offering to current proposed solution',
      metricevolutionLabelText: 'Provide one metric to measure the evolution of the customer problem.',
      metricevolutionHintText: 'Provide one metric which will help measure the change in the original customer problem. This can help the solution team decide on if the solution is still relevant to solving the problem of the customer or a new solution paradigm needs to be introduced.',
      metrictitle2: 'Number of active API adopters per month',
      metricecosystemLabelText: '(Optional) Provide one metric for new parallel solutions.',
      metricecosystemHintText: 'If the problem has evolved significantly and one or more new solutions can be suggested, Please provide one metric which will help measure the usefulness of parallel product concepts built around the original solution idea.',
            
       
      textInputRules: [
        v => !!v || 'This field is required',
        v => v.length >= 3 || 'Minimum length is 3 characters'
      ],
      selectInputRules: [
        v => !!v || 'This field is required'
      ],
      loading: false
    }
  },
  methods: {
    submit(){
 if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            const scaledetail = {
                handlingscaledetails: this.handlingscaledetails,
                isthegrowthsustainable: this.isthegrowthsustainable 
            }
 

            db.collection('projects').doc(this.getProjectID()).update(scaledetail).then(() => {
                    //console.log("added to db!", docRef.id)
                    this.loading = false;
                    this.dialog = false;
                    this.$router.push('dumaddparallelinnovations')
                    ///this.$emit('firstprefdetailsconfirmed')
                });


const metric = {
                metrictitle: this.metrictitle,
                metriccategory: 'Evolution'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projectadded')
       });

       const metric2 = {
                metrictitle: this.metrictitle2,
                metriccategory: 'Ecosystem'
            }
 

            //Yx3r6dHUeFFdGvY6Acvy

           db.collection('projects').doc(this.getProjectID()).collection('metrics').add(metric2).then(() => {
          //console.log("added to db!", docRef.id)
          //nameofthesolution = '';
          //briefdescriptionofthesolution = '';
          this.loading = false;
          this.dialog = false;
          //this.$emit('projectadded')
       });


            //Yx3r6dHUeFFdGvY6Acvy
 

             }

    },
    getProjectID(){
      return gvars.PROJECTID;
    }
    
  },
  computed: {
    
  }
};
</script>

<style>
</style>
